import { Component, Input } from "@angular/core";

@Component({
  selector: "copy-to-clipboard",
  template: `
    <!-- El kit de Font Awesome sustituye el <i> por un <svg>: el click va en el botón -->
    <button
      type="button"
      [copyToClipboard]="content"
      class="action bg-transparent border-0 p-0 text-gray-600 hover:text-gray-900 transition"
      style="cursor: pointer"
      aria-label="Copiar al portapapeles"
    >
      <i class="fas fa-copy"></i>
    </button>
  `,
})
export class CopyToClipboardComponent {
  @Input() content: string;
}
